// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import StoreSaveCartState from "@store/Framework/Store/Store/Components/SaveCart/SaveCartState";
import { Draft } from "immer";

const initialState: StoreSaveCartState = {
    isOpen: false,
    cartLabel: "",
    cartToLoadAfter: undefined,
};

const actions = {
    "Store/Components/SaveCart/CompleteSetIsOpen": (
        draft: Draft<StoreSaveCartState>,
        action: {
            isOpen: boolean;
            cartToLoadAfter?: CartModel;
        },
    ) => {
        draft.isOpen = action.isOpen;
        if (!action.isOpen) {
            draft.cartLabel = "";
            draft.cartToLoadAfter = undefined;
        } else {
            draft.cartToLoadAfter = action.cartToLoadAfter;
        }
    },
    "Store/Components/SaveCart/SetSaveCartLabel": (
        draft: Draft<StoreSaveCartState>,
        action: {
            cartLabel: string;
        },
    ) => {
        draft.cartLabel = action.cartLabel;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreSaveCartActions = Parameters<typeof reducer>[1];
export default reducer;
